export default [
  {
    path: '/sales-completions',
    name: 'SalesCompletionsList',
    component: () => import('pages/sales-completions/list/SalesCompletionsList.vue')
  },
  {
    path: '/sales-completions/:id',
    name: 'SalesCompletionsSingleLayout',
    component: () => import('pages/sales-completions/single/_layouts/SalesCompletionsSingleLayout.vue'),
    redirect: { name: 'SalesCompletionsEdit' },
    children: [
      {
        path: '/sales-completions/:id/edit',
        name: 'SalesCompletionsEdit',
        component: () => import('pages/sales-completions/single/tabs/edit/SalesCompletionsEdit.vue')
      },
      {
        path: '/sales-completions/:id/history',
        name: 'SalesCompletionsHistoryList',
        component: () => import('pages/sales-completions/single/tabs/SalesCompletionsHistoryList.vue')
      },
      {
        path: '/sales-completions/:id/contracts',
        name: 'SalesCompletionsContractsSingle',
        component: () => import('pages/sales/contracts/SalesContractsSingle.vue')
      },
      {
        path: '/sales-completions/:id/comments',
        name: 'SalesCompletionsCommentsList',
        component: () => import('pages/sales-completions/single/tabs/comments/SalesCompletionsCommentsList.vue')
      }
    ]
  }
]
